export default __webpack_public_path__ + "e0b21463f56b930cd703e00897f61004.png";